module.exports = function() {
  return new Worker(__webpack_public_path__ + "b80fba9f6ab6b0b82188.worker.js");
};